const state = {
  processTypes: [],
  processSettings:[],
  currentProcess:{},
  toDo: [],
  done: [],
  success: [],
  lost: [],
  blank:'',
  closeAll: false,
  chosenSelect:''
};

const mutations = {
  SET_BLANK(state, blank) {
    state.blank = blank;
  },
  SET_PROCESS(state, process) {
    state.currentProcess = process;
  },
  SET_SETTINGS(state, settings) {
    state.processSettings = settings;
  },
  SET_TYPES(state, types) {
    state.processTypes = types;
  },
  SET_TODO(state, processes) {
    state.toDo = processes;
  },
  SET_DONE(state, processes) {
    state.done = processes;
  },
  SET_SUCCESS(state, processes) {
    state.success = processes;
  },
  SET_LOST(state, processes) {
    state.lost = processes;
  },
  SET_CHOSEN_SELECT(state, name) {
    state.chosenSelect = name;
  },
};

const getters = {
  getCurrentProcess: (state) => {
    return state.currentProcess;
  },
  getProcessSettings: (state) => {
    return state.processSettings;
  },
  getProcessTypes: (state) => {
    return state.processTypes;
  },
  getToDo: (state) => {
    return state.toDo;
  },
  getDone: (state) => {
    return state.done;
  },
  getSuccess: (state) => {
    return state.success;
  },
  getLost: (state) => {
    return state.lost;
  },
  getChosenSelect: (state) => {
    return state.chosenSelect
  }
};

export default {
  state,
  mutations,
  getters,
};
